import { Button, Grid, Stack, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import CustomSwitch from '../../../../BusinessSettings/Components/BussinessCertification/components/CustomSwitch';
import { LanguageContext } from '../../../../../libs/Context';
import { catchErr } from '../../../../../libs/HelperContent';
import { updateMeeting } from '../../../../actions/meeting_actions';

const Engagement = (props) =>
{
	const { form, activeStep, setForm, handleDeletePop, handleBack, handleNext } = props;
	const { language } = useContext(LanguageContext);

	const data = [
		{
			apiKey    : 'chat',
			value     : form?.chat,
			content   : language.chat,
			descption : language.ChatDesc,
			icon      : <img src='/images/webChat.svg' alt='Q&A' className='imgAvatarXSM' />
		},
		{
			apiKey    : 'reactions',
			value    	: form?.reactions,
			content   : language.reactions,
			descption : language.reactionsDecs,
			icon      : <img src='/images/webReactions.svg' alt='Q&A' className='imgAvatarXSM' />
		},
		{
			apiKey    : 'polls',
			value    	: form?.polls,
			content   : language.polls,
			descption : language.pollsDesc,
			icon      : <img src='/images/webPolls.svg' alt='Q&A' className='imgAvatarXSM' />
		},
		{
			apiKey    : 'resources',
			value    	: form?.resources,
			content   : language.resources,
			descption : language.resourcesDesc,
			icon      : <img src='/images/webResource.svg' alt='Q&A' className='imgAvatarXSM' />
		},
		{
			apiKey    : 'surveys',
			value    	: form?.surveys,
			content   : language.survey,
			descption : language.surveyInfoDesc,
			icon      : <img src='/images/webSurvey.svg' alt='Q&A' className='imgAvatarXSM' />
		}
	];

	const [ toggleState, setToggleState ] = useState(data?.reduce((acc, item) =>
	{
		acc[item?.apiKey] = Boolean(item?.value);

		return acc;
	}, {}));

	const updateWebinar = async () =>
	{
		try
		{
			const body = {
				actionType : 'updateWebinar',
				id         : form?.id,
				...toggleState
			};

			const res = await updateMeeting(body);

			if (res?.status)
			{
				setForm((prev) => ({ ...prev, ...toggleState }));

				handleNext();
			}
		}
		catch (err)
		{
			catchErr(err);
		}
	};

	const handleToggleChange = (apiKey) =>
	{
		setToggleState((prev) => ({
			...prev,
			[apiKey] : !prev[apiKey]
		}));
	};

	return (
		<>
			<Stack direction='column' height='calc(100% - 56px)'>
				<Grid container px='var(--pixel16)' py='6px'>
					<Typography variant='inherit'>{language.selectwaytoengageAttendense}</Typography>
					<Grid item xs={12} pt='var(--pixel12)'>
						{data.map((item) => (
							<Stack direction='row' justifyContent='space-between' key={item.apiKey} spacing={1} py='var(--pixel12)'>
								<Stack direction='row' spacing={2} alignItems={'center'}>
									<Typography variant='inherit'>{item.icon}</Typography>
									<Stack direction='column'>
										<Typography variant='inherit' fontWeight='var(--font500)'>{item.content}</Typography>
										<Typography>{item.descption}</Typography>
									</Stack>
								</Stack>
								<CustomSwitch
									toggleEnabled={toggleState[item.apiKey]}
									handleToggleChange={() => handleToggleChange(item.apiKey)}
								/>
							</Stack>
						))}
					</Grid>
				</Grid>
			</Stack>
			<Grid
				container
				justifyContent={activeStep === 1 ? 'flex-end' : 'space-between'}
				alignItems='center'
				p='var(--pixel16)'
			>
				{activeStep !== 1 && (
					<Stack direction='row' alignItems='center' spacing={1}>
						<Button variant='outlined' onClick={handleBack}>
							{language?.previous}
						</Button>
						{activeStep !== 7 && (
							<Button variant='outlined'>
								{language?.skipandFinish}
							</Button>
						)}
					</Stack>
				)}
				<Grid item>
					<Stack direction='row' spacing={1}>
						<Button onClick={handleDeletePop} variant='outlined'>
							{language?.cancel}
						</Button>
						<Button variant='contained' sx={{ color: 'var(--whiteColor)' }} onClick={updateWebinar}>
							{activeStep === 7 ? 'Next' : language?.next}
						</Button>
					</Stack>
				</Grid>
			</Grid>
		</>
	);
};

export default Engagement;
